import * as Yup from "yup";
import {
    useLoginApiMutation,
} from "../../redux/api/authApi/authApi";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import loginLine from "../../assets/images/loginLine.png";
import logo from "../../assets/images/tasnuva_courier.png";
import CustomInput from "../../components/CustomInput";
import CustomLoading from "../../components/CustomLoading";

const Login = () => {
    const [loginMerchant, result] = useLoginApiMutation();
    const navigate = useNavigate();

    const validationSchema1 = Yup.object().shape({
        email: Yup.string()
            .email("Invalid email address")
            .required("Email is required"),
        password: Yup.string()
            .min(6, "Password must be at least 6 characters")
            .required("Password is required"),
    });

    const initialValues1 = {
        email: "",
        password: "",
    };

    const formik1 = useFormik({
        initialValues: initialValues1,
        validationSchema: validationSchema1,
        onSubmit: async (values) => {
            try {
                await loginMerchant(values).unwrap();
                toast.success("Successfully logged in!");
                navigate("/");
            } catch (error) {
                console.log(error);
                toast.error(error?.data?.message || "Something went wrong!");
            }
        },
    });

    return (
        <div className="flex flex-row w-full h-[100vh] justify-center items-center">
            <div className="h-auto flex flex-row shadow rounded-r-2xl overflow-hidden">
                <div
                    data-aos="fade-right"
                    className="py-14 px-10 flex-col gap-4 justify-center items-center relative bg-primary md:flex hidden"
                >
                    <div>
                        <img
                            alt="login"
                            src="https://res.cloudinary.com/di23omfvx/image/upload/v1692419215/login_lzs3ti.gif"
                            className="w-[300px]"
                        />
                    </div>
                    <div>
                        <div className="text-center text-white text-xl">
                            Connecting to all Services
                        </div>
                        <div className="text-center !text-[#f4f4f4] text-sm">
                            Safe and swift delivery of the items.
                        </div>
                        <div className="absolute bottom-0 left-0">
                            <img alt="login" src={loginLine} className="h-36 w-36" />
                        </div>
                    </div>
                </div>
                <div
                    data-aos="fade-left"
                    className="py-14 px-10 flex flex-col justify-center items-center bg-white"
                >
                    <div className="text-center flex flex-col gap-3 items-center">
                        <img alt="login" src={logo} className="w-[250px]" />
                        <div className="text-2xl text-text_1 font-bold">
                            Log In to Branch Panel
                        </div>
                        <div className="text-text_2">
                            Enter your email address and password below
                        </div>
                    </div>
                    <form
                        onSubmit={formik1.handleSubmit}
                        className="w-full flex flex-col gap-2 mt-5"
                    >
                        <CustomInput
                            label="EMAIL"
                            type="email"
                            setFieldValue={formik1.setFieldValue}
                            value={formik1.values.email}
                            touched={formik1.touched.email}
                            error={formik1.errors.email}
                            handleBlur={formik1.handleBlur}
                        />
                        <CustomInput
                            label="PASSWORD"
                            type="password"
                            setFieldValue={formik1.setFieldValue}
                            value={formik1.values.password}
                            touched={formik1.touched.password}
                            error={formik1.errors.password}
                            handleBlur={formik1.handleBlur}
                        />
                        <button
                            type="submit"
                            className="w-full text-white text-center py-3 rounded-xl text-xl bg-text_1 shadow mt-5 cursor-pointer hover:animate-pulse transition-all"
                        >
                            Log In
                        </button>
                    </form>
                </div>
            </div>

            {(result?.isLoading) && <CustomLoading />}
        </div>
    );
};

export default Login;
